import * as React from 'react';

interface FormTextProps {
  value?: string;
  className?: string;
}

const FormText: React.FC<FormTextProps> = ({ value, className }) => <div className={className}>{value || '-'}</div>;
export default FormText;
